import React, { useEffect, useState } from "react";
import LoadingPage from "../Loading/loading";
import { Cookies } from "react-cookie";
import { ToastContainer, toast } from "react-toastify";
import { deleteProjects, getProjects } from "../../network/api/projects";

const ViewProjectsPage = () => {
  const cookie = new Cookies();
  const [isSuper, setIsSuper] = useState(cookie.get("super"));
  const [projectsSelected, setProjectsSelected] = useState([]);
  const [projects, setProjects] = useState(null);
  const [showDelete, setShowDelete] = useState(null);
  const [pageCount, setPageCount] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  const [currentPage, setCurrentPage] = useState(
    Number(cookie.get("projects_page")) || 1,
  );

  const handleSelect = (id) => {
    if (projectsSelected.includes(id)) {
      setProjectsSelected(projectsSelected.filter((item) => item !== id));
    } else {
      setProjectsSelected([...projectsSelected, id]);
    }
  };

  const projectsGet = async () => {
    try {
      setProjects(null);
      const result = await getProjects(currentPage);

      setProjects(result.data.projects);
      setPageCount(result.data.pageCount);
      setTotalCount(result.data.totalCount);
    } catch {
      toast.error("Failed to load projects");
      setProjects([]);
    }
  };

  useEffect(() => {
    projectsGet();
  }, [currentPage]);

  const handlePageClick = (page) => {
    setCurrentPage(page);
    cookie.set("projects_page", page);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      cookie.set("projects_page", currentPage - 1);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  const handleNext = () => {
    if (currentPage < pageCount) {
      setCurrentPage(currentPage + 1);
      cookie.set("projects_page", currentPage + 1);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  const renderPageNumbers = () => {
    let pages = [];

    if (pageCount <= 10) {
      // Show all pages if less than 10
      for (let i = 1; i <= pageCount; i++) {
        pages.push(i);
      }
    } else {
      // Always show 1-10
      if (currentPage <= 10) {
        for (let i = 1; i <= 10; i++) {
          pages.push(i);
        }
        pages.push("...");
        pages.push(pageCount);
      } else {
        // After page 10, show current - 2 to current + 2
        pages.push(1);
        pages.push("...");
        let start = Math.max(currentPage - 2, 2);
        let end = Math.min(currentPage + 2, pageCount - 1);

        for (let i = start; i <= end; i++) {
          pages.push(i);
        }

        if (end < pageCount - 1) {
          pages.push("...");
        }
        pages.push(pageCount);
      }
    }

    return pages.map((page, index) =>
      page === "..." ? (
        <span key={index} className="px-2">
          ...
        </span>
      ) : (
        <button
          key={index}
          onClick={() => handlePageClick(page)}
          className={
            currentPage === page ? "paginationButtonActive" : "paginationButton"
          }
        >
          {page}
        </button>
      ),
    );
  };

  const handleDelete = () => {
    deleteProjects({ projects: projectsSelected }).then((result) => {
      if (result.data.message === "Projects deleted successfully") {
        setProjectsSelected([]);
        setShowDelete(false);
        handlePageClick(1);
        toast.success(result.data.message, {
          position: "top-right",
        });
        projectsGet();
      } else {
        toast.error(result.data.message, {
          position: "top-right",
        });
      }
    });
  };

  return (
    <>
      {projects === null ? (
        <LoadingPage />
      ) : (
        <div className="channel-page">
          {/* HEADER */}
          <div className="page-header">
            <h2>Projects</h2>
            <span>{totalCount || 0} Projects</span>
            {projectsSelected.length > 0 && (
              <>
                {isSuper && (
                  <button
                    className="assignbtn"
                    onClick={() => {
                      setShowDelete(true);
                    }}
                  >
                    Delete {projectsSelected.length} Projects
                  </button>
                )}
              </>
            )}
          </div>

          {/* DESKTOP TABLE */}
          <div className="table-scroll">
            <div className="table-container">
              <table className="modern-table">
                <thead>
                  <tr>
                    {isSuper && <th>Select</th>}
                    <th>Name</th>
                    <th>Region</th>
                    <th>Date</th>
                  </tr>
                </thead>

                <tbody>
                  {projects?.map((item) => (
                    <tr key={item._id}>
                      {isSuper && (
                        <td>
                          <input
                            id="check"
                            type="checkbox"
                            checked={projectsSelected.includes(item?._id)}
                            onChange={() => {
                              handleSelect(item._id);
                            }}
                          />
                        </td>
                      )}
                      <td>{item.name}</td>
                      <td>{item.region}</td>
                      <td>{new Date(item.createdAt).toLocaleDateString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* MOBILE CARDS */}
          <div className="cards-container">
            {projects?.map((item) => (
              <div className="channel-card" key={item._id}>
                <div className="card-title">{item.name}</div>
                <div className="card-date">
                  {new Date(item.createdAt).toLocaleDateString()}
                </div>
              </div>
            ))}
          </div>

          <div
            className="mt-4"
            style={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
              padding: "10px",
            }}
          >
            {currentPage !== 1 && (
              <button
                onClick={handlePrevious}
                disabled={currentPage === 1}
                className="paginationButton"
              >
                Previous
              </button>
            )}
            {renderPageNumbers()}
            {currentPage !== pageCount && pageCount > 0 && (
              <button
                onClick={handleNext}
                disabled={currentPage === pageCount}
                className="paginationButton"
              >
                Next
              </button>
            )}
          </div>
        </div>
      )}

      {showDelete && (
        <div className="popup-overlay">
          <div
            className="popup-box popup-animation"
            onClick={(e) => e.stopPropagation()}
          >
            {/* HEADER */}
            <div className="popup-header">
              <h2>Delete projects</h2>
              <button
                className="close-btn"
                onClick={() => setShowDelete(false)}
              >
                ✕
              </button>
            </div>

            <div className="show-lead row gap-3">
              <div className="item-edit d-flex col-5 align-items-center">
                <p>You want to delete this projects?</p>
              </div>
            </div>
            <div className="popup-actions">
              <button
                className="cancel-btn"
                onClick={() => setShowDelete(false)}
              >
                No
              </button>

              <button className="confirm-btn" onClick={handleDelete}>
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
      <ToastContainer />
    </>
  );
};

export default ViewProjectsPage;
